module.exports = __webpack_public_path__ + "img/pr-6.9ed75191.png";